import { FC, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

interface Props {
	title: string;
	confirmCode: string;
	confirmHint: string;
	confirmLabel: string;

	isOpen: boolean;
	onCancel: () => void;
	onConfirm: () => void;
}

/**
 * ConfirmDelete renders the dialog box that acts as a barrier for accidentally delete resources.
 *
 * @param title        the title string, usually the question that asks users if they want to delete the resource
 * @param confirmCode  the string that users must manually confirm by typing it in the provided text field
 * @param confirmHint  the string that informs uses about what text should be typed in the confirmation text field
 * @param confirmLabel the label rendered above the confirmation text field
 * @param isOpen       the flag indicating if the dialog is visible
 * @param onCancel     the cancel handler
 * @param onConfirm    the confirm handler
 * @constructor
 */
const ConfirmDelete: FC<Props> = ({ title, confirmCode, confirmHint, confirmLabel, isOpen, onCancel, onConfirm }) => {
	const { t } = useTranslation("feature.users");
	const [confirmed, setConfirmed] = useState<string>("");

	// type email {email}, then confirm to delete user

	return (
		<Dialog open={isOpen} onClose={onCancel}>
			<DialogTitle>{title}</DialogTitle>
			<DialogContent>
				<Stack direction="column" spacing={2}>
					<Typography>{confirmHint}</Typography>
					<TextField label={confirmLabel} value={confirmed} onChange={(v) => setConfirmed(v.target.value)} />
				</Stack>
			</DialogContent>
			<DialogActions>
				<Button className="cancel" disabled={confirmCode !== confirmed} onClick={onConfirm}>
					{t("ok")}
				</Button>
				<Button className="confirm" onClick={onCancel}>
					{t("cancel")}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default ConfirmDelete;
